import React, { useState } from "react";

import _theme from "../../styles/theme";
import Icon, { ClickableIcon } from "../../components/Icon";
import Dropdown, {
  DropdownContainer,
  DropdownItem,
} from "../../components/Dropdown";


type InstructorDropdownProps = {
  instructor: { [key: string]: any };
  openEditModal: (x: any, e?: any) => void;
};

const InstructorDropdown = ({
  instructor,
  openEditModal,
}: InstructorDropdownProps) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <DropdownContainer>
      <ClickableIcon
        ml={0.5}
        size={2}
        name="more-vertical"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!isOpen);
        }}
        style={{ color: _theme.color.primary }}
      />
      <Dropdown
        open={isOpen}
        style={{ whiteSpace: "nowrap" }}
        setOpen={setOpen}
        align="right"
      >
        <DropdownItem
          to="#"
          onClick={(e: any) => {
            e.stopPropagation();
            setOpen(false);
            openEditModal(instructor);
          }}
          style={{minWidth: '80px'}}
        >
          <Icon mr={1} name="pencil-edit" /> Edit
        </DropdownItem>

        {/* <DropdownItem
          to="#"
          onClick={(e: any) => {
            setOpen(false);
            openEditModal(instructor, e);
          }}>
          <RemoveCourse>
            <Icon mr={1} name="trash-empty" /> Delete Instructor
          </RemoveCourse>
        </DropdownItem> */}
      </Dropdown>
    </DropdownContainer>
  );
};

export default InstructorDropdown;
